import { useLocation, useNavigate } from 'react-router-dom'
import { PLACEHOLDER_ROUTES } from '../lib/navigation'
import SidebarIcon from '../components/SidebarIcon'

/**
 * Tela exibida para itens de menu ja publicados na navegacao
 * mas cuja implementacao ainda nao faz parte desta entrega.
 */
export default function EmConstrucao() {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const info = PLACEHOLDER_ROUTES[pathname]

  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '40px 24px' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          color: '#62666d',
          fontSize: 12,
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
          marginBottom: 18,
        }}
      >
        <SidebarIcon name="settings" size={14} color="#62666d" />
        Módulo em preparação
      </div>

      <h1 style={{ color: '#f7f8f8', fontSize: 22, fontWeight: 600, marginBottom: 10 }}>
        {info?.titulo ?? 'Em construção'}
      </h1>

      <p style={{ color: '#8a8f98', fontSize: 13, lineHeight: 1.65, marginBottom: 26 }}>
        {info?.descricao ??
          'Esta tela ainda não faz parte da Fase 1 do Núcleo Financeiro.'}
      </p>

      <div
        className="card"
        style={{ padding: '18px 20px', display: 'flex', flexDirection: 'column', gap: 10 }}
      >
        <p style={{ color: '#d0d6e0', fontSize: 13, fontWeight: 500 }}>
          O que já está disponível agora
        </p>
        <p style={{ color: '#8a8f98', fontSize: 12, lineHeight: 1.6 }}>
          O fluxo completo de orçamento, suprimentos, contas a pagar e pagamentos segue
          operando normalmente. Esta entrada foi criada apenas para reservar o lugar do
          módulo no menu, mantendo a navegação e as permissões já configuradas.
        </p>
        <div style={{ display: 'flex', gap: 8, marginTop: 6, flexWrap: 'wrap' }}>
          <button className="btn-primary" onClick={() => navigate('/dashboard')}>
            Ir para o Dashboard
          </button>
          <button className="btn-ghost" onClick={() => navigate('/orcamento')}>
            Ver Orçamentos
          </button>
        </div>
      </div>
    </div>
  )
}
